import React from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          padding: 20,
          background: "#fff",
          borderRadius: 5,
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          width: "70%",
        }}
        className="modal"
      >
        <div>{children}</div>
        <div className="modal__buttonsContainer">
          <button
            className="modal__button modal__button--annuler text-page-light text-page-light--blackSmall"
            onClick={onClose}
          >
            Annuler
          </button>
          <button
            className="modal__button modal__button--confirmer text-page-light text-page-light--blackSmall"
            onClick={onConfirm}
          >
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );
};
export default Modal;
